module.exports = __webpack_public_path__ + "static/media/php_development.81aee8d2.svg";